import PricingSection from "../components/PricingSection";
import PricingHeader from "../components/PricingHeader";
import PricingCTA from "../components/PricingCTA";

const Pricing = () => {
    return (
        <>
            <PricingHeader />
            <PricingSection/>
            <PricingCTA />
        </>
    )
}

export default Pricing;